/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { render } from '../lib';
import { VimeDefaultSettings, VimeIcon, VimeMenu, VimeMenuItem, VimeMenuRadio, VimeMenuRadioGroup, VimeSettings, VimeSubmenu } from '@vime/core';
import { define } from '../lib';
define('vime-default-settings', VimeDefaultSettings);
define('vime-icon', VimeIcon);
define('vime-menu', VimeMenu);
define('vime-menu-item', VimeMenuItem);
define('vime-menu-radio', VimeMenuRadio);
define('vime-menu-radio-group', VimeMenuRadioGroup);
define('vime-settings', VimeSettings);
define('vime-submenu', VimeSubmenu);
export default Vue.extend({
    props: {
        pin: {},
        i18n: {},
        playbackReady: {},
        playbackRate: {},
        playbackRates: {},
        playbackQuality: {},
        playbackQualities: {},
        isCaptionsActive: {},
        currentCaption: {},
        textTracks: {},
    },
    methods: {},
    render: render('vime-default-settings', []),
});
//# sourceMappingURL=VimeDefaultSettings.js.map